import type { EditorElement, EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';
import type { ComponentType } from 'react';

export const UNDERLINE_PLUGIN_ID = 'underline' as const;
export type UnderlinePluginID = typeof UNDERLINE_PLUGIN_ID;

export type UnderlinePluginElement = EditorElement;

export type UnderlinePluginOptions = Readonly<
  EditorPluginOptions & {
    component?: ComponentType<any>;
  }
>;

export type UnderlinePluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    UnderlinePluginOptions & {
      pluginID: UnderlinePluginID;
      hotkey: string;
      component: ComponentType<any>;
      pluginName: string;
      icon: ComponentType<any>;
    }
>;
